module.exports = __webpack_public_path__ + "img/ml.f183edc3.svg";